<template>
  <div></div>
</template>

<script>

import NetworkSpeed from 'network-speed';
import GridMixin from '@/mixins/GridMixin';
import { isNil } from 'lodash';
import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';

export default {
  name: 'Hint',

  mixins: [GridMixin, HotelmeisterMixin, UpdateHotelSettingsMixin],

  props: {
  },

  data: function () {
    return {
      testNetworkSpeed: new NetworkSpeed(),
    };
  },

  created: function () {
    this.$serviceBus.$on('speedtest', this.test);
    this.$serviceBus.$on('speedtest.silent', this.testSilent);
  },

  methods: {
    test: async function () {
      const baseUrl = `https://hotelmeistercdn.s3.eu-central-1.amazonaws.com/img/testimage.jpg?n=${Math.random()}`;
      const fileSizeInBytes = 5616998;
      const speed = await this.testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
      this.showWarningMessage(`${speed.mbps} mbps`, 'Internet Speed');
      this.axios.post(this.serviceUrls.speedlog(this), speed);
    },
    testSilent: async function () {
      const baseUrl = `https://hotelmeistercdn.s3.eu-central-1.amazonaws.com/img/testimage.jpg?n=${Math.random()}`;
      const fileSizeInBytes = 5616998;
      const speed = await this.testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
      this.axios.post(this.serviceUrls.speedlog(this), speed);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/lib/util/Speedtest.vue